<template>
  <div class="statistics_panel_wrap" v-loading="loading">
    <!--  -->
    <div class="data_add">
      <div class="card data_add_every total_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.transTotalNumber}}</span>
          <span>总翻译字数</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.transTotalNumber}}</span>
            <span class="title">总翻译字数</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>
      <div class="card data_add_every total_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.transRedoNumber}}</span>
          <span>翻译重复字数</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.transRedoNumber}}</span>
            <span class="title">翻译重复字数</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>
      <div class="card data_add_every total_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.fileTotalNumber}}</span>
          <span>总文件数</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.fileTotalNumber}}</span>
            <span class="title">总文件数</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>
    </div>

    <div class="tit">
      <i></i>
      项目数据
    </div>
    <!-- 项目数据 -->
    <div class="project_data">
      <div class="card data_add_every pro_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.projectTotalNumber}}</span>
          <span>项目总数</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.projectTotalNumber}}</span>
            <span class="title">项目总数</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>
      <div class="card data_add_every pro_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.projectOverNumber}}</span>
          <span>已完成项目</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.projectOverNumber}}</span>
            <span class="title">已完成项目</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>
      <div class="card data_add_every pro_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.projectUnfinishedNumber}}</span>
          <span>进行中项目</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.projectUnfinishedNumber}}</span>
            <span class="title">进行中项目</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>
      <div class="card data_add_every task_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img_lower"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.taskTotalNumber}}</span>
          <span>任务完成总数</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.taskTotalNumber}}</span>
            <span class="title">任务完成总数</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>
      <div class="card data_add_every task_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img_lower"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.taskOverNumber}}</span>
          <span>已完成任务</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.taskOverNumber}}</span>
            <span class="title">已完成任务</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>
      <div class="card data_add_every task_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img_lower"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.taskUnfinishedNumber}}</span>
          <span>进行中任务</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.taskUnfinishedNumber}}</span>
            <span class="title">进行中任务</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>

    </div>
    <div class="tit">
      <i></i>
      团队数据
    </div>
    <!-- 团队数据 -->
    <div class="team_data">
      <div class="card data_add_every group_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.userTotalNumber}}</span>
          <span>团队总数</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.userTotalNumber}}</span>
            <span class="title">团队总数</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>
      <div class="card data_add_every group_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.userJoinNumber}}</span>
          <span>已加入人数</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.userJoinNumber}}</span>
            <span class="title">已加入人数</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>
      <div class="card data_add_every group_data">
        <!-- <div class="data_add_logo">
          <i class="data_add_img"></i>
        </div>
        <div class="data_add_center">
          <span>{{statisticsObj.userNotJoinNumber}}</span>
          <span>未加入人数</span>
        </div> -->
        <div class="cen-box">
          <div class="icon-box"></div>
          <div class="rig-box">
            <span class="content">{{statisticsObj.userNotJoinNumber}}</span>
            <span class="title">未加入人数</span>
            <div class="bor-box">
              <div class="col-bor"></div>
              <div class="def-bor"></div>
            </div>
          </div>
        </div>
        <div class="bot-box"></div>
      </div>

    </div>
  </div>
</template>

<script>
export default {

  name: "StatisticsPanel",
  data() {
    return {
      statisticsObj: {},
      loading: false,
    };
  },
  created() {
    this.loading = true
    this.queryUserStatistics()
  },
  methods: {
    async queryUserStatistics() {
      let url = "/api/v1/common/queryUserStatistics"
      try {
        const res = await this.catReq1Service(url)
        if (!res.success) {
          return
        }
        this.loading = false
        this.statisticsObj = res.result
      } catch (error) {

      }


    },

  },
};
</script>

<style lang="less" scoped>
.statistics_panel_wrap {
  height: 100%;
  overflow: auto;
  .data_add {
    // width: 1270px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    margin-left: 30px;
    .data_add_img {
      display: inline-block;
      background: url("../../assets/imgs/project/zishu.png") center no-repeat;
    }
  }
  .project_data {
    // width: 1270px;
    // height: 282px;
    margin-left: 30px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    .data_add_img {
      display: inline-block;
      background: url("../../assets/imgs/project/xiangmu.png") center no-repeat;
    }
    .data_add_img_lower {
      display: inline-block;
      background: url("../../assets/imgs/project/renwu.png") center no-repeat;
    }
  }
  .team_data {
    // width: 1270px;
    margin-left: 30px;
    display: flex;
    flex-wrap: wrap;
    .data_add_img {
      display: inline-block;
      background: url("../../assets/imgs/project/renshu.png") center no-repeat;
    }
  }
  /*卡片*/
  .card {
    width: 390px;
    height: 132px;
    background: #ffffff;
    background: #ffffff;
    border-image: linear-gradient(163deg, #e8e6e6, #f5f1f1, #e8e6e6) 10 10;
    box-shadow: 0px 0px 15px 0px rgba(215, 216, 219, 0.4);
    border-radius: 20px;
    margin-right: 100px;
    margin-bottom: 38px;
    position: relative;
    padding-top: 36px;
    box-sizing: border-box;
  }
  /*卡片 end*/
  /*卡片内布局*/
  .cen-box {
    display: flex;
    margin-left: 20px;
    .title {
      font-weight: bold;
      color: #777777;
      font-size: 16px;
      text-align: left;
    }
    .content {
      font-weight: bold;
      color: #454545;
      font-size: 20px;
      text-align: left;
    }
    .rig-box {
      width: 260px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .bor-box {
        width: 100%;
        display: flex;
        height: 2px;
        margin-top: 4px;
        & > div {
          height: 2px;
          border-radius: 1px;
        }
        .col-bor {
          width: 40%;
        }
        .def-bor {
          width: 60%;
          background: #e1e3eb;
        }
      }
    }
  }
  .icon-box {
    width: 48px;
    height: 48px;
    margin-right: 20px;
  }
  // .bot-box {
  //   width: 50px;
  //   height: 28px;
  //   background: url("../../assets/imgs/project/get_into.png") center center
  //     no-repeat;
  //   background-size: cover;
  //   float: right;
  //   margin-right: 20px;
  // }
  .total_data {
    .icon-box {
      background: url("../../assets/imgs/project/number_of_words.png") center
        center no-repeat;
      background-size: cover;
    }
    .col-bor {
      background: #33c392;
    }
  }
  .pro_data {
    .icon-box {
      background: url("../../assets/imgs/project/number_of_projects.png") center
        center no-repeat;
      background-size: cover;
    }
    .col-bor {
      background: #4183ff;
    }
  }
  .task_data {
    .icon-box {
      background: url("../../assets/imgs/project/number_of_tasks.png") center
        center no-repeat;
      background-size: cover;
    }
    .col-bor {
      background: #e7b757;
    }
  }
  .group_data {
    .icon-box {
      background: url("../../assets/imgs/project/total_number_of_teams.png")
        center center no-repeat;
      background-size: cover;
    }
    .col-bor {
      background: #f3ba01;
    }
  }

  .data_add_every {
    // display: flex;
    .data_add_logo {
      flex-grow: 4;
      line-height: 110px;
      i {
        width: 38px;
        height: 38px;
        vertical-align: middle;
      }
    }
    .data_add_center {
      flex-grow: 6;
      display: flex;
      text-align: left;
      flex-direction: column;
      span:first-child {
        height: 50%;
        font-size: 24px;
        line-height: 80px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(69, 69, 69, 1);
      }
      span:last-child {
        height: 50%;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(69, 69, 69, 1);
      }
    }
  }

  /*卡片内布局 end*/
  /*标题*/
  .tit {
    text-align: left;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    // margin-top: 38px;
    margin-bottom: 18px;
    margin-left: 10px;
    i {
      display: inline-block;
      position: relative;
      top: 2px;
      width: 4px;
      height: 18px;
      background: linear-gradient(0deg, #37a1f2 0%, #aed0ff 100%);
      border-radius: 2px;
    }
  }
  /*标题 end*/
}
</style>
